import { withImageParams } from './imageUrl';

export const DASHBOARD_ORIGIN_SURFACE = 'dashboard';

export type DashboardEntrySource = 'nav' | 'mobile_menu';

/**
 * Dashboard link that records how the customer entered as a `source` query
 * param. The platform page-view event that fires on `/dashboard` reads it from
 * the destination URL, so no dashboard-specific Journey event is needed.
 */
export const dashboardHref = (source: DashboardEntrySource): string =>
  `/dashboard?source=${source}`;

/**
 * Stamps a navigation target with the dashboard origin-surface marker so the
 * destination can attribute the visit back to the customer dashboard. The
 * surface travels as an explicit `originSurface` query param — read from the
 * destination's own URL by the platform page-view event — which works for both
 * same-origin (relative) and cross-origin (absolute) links and, unlike shared
 * session state, cannot leak into unrelated later flows.
 */
export const withDashboardOriginSurface = (href: string): string =>
  withImageParams(href, { originSurface: DASHBOARD_ORIGIN_SURFACE });
